import { useContext, useEffect, useState } from 'react';
import LayersContext from '../context/LayersContext';
import StoryCard from '../components/storymap/StoryCard';

const Storymap: React.FC = () => {
    const { layers, loading, fetchLayersData } = useContext(LayersContext);
    const isIframe = window !== window.parent;
    const [activeLayer, setActiveLayer] = useState<string | null>(null);
    const [activeCardId, setActiveCardId] = useState<number | null>(null); // Track active card


    console.log('Is Iframe?:', isIframe);
    console.log('storymap layers:', layers);
    useEffect(() => {
        if (layers.length > 0 && !activeLayer) {
            console.log('Setting active layer:', activeLayer);
            setActiveLayer(layers[0].layer_name);
        }
    }, [layers]);

    console.log('storymap layers:', layers);
    
    // Get the layer items from the active layer
    const activeLayerData = layers?.find(layer => layer.layer_name === activeLayer);
    const layerItems = activeLayerData?.items || [];

    // Check if layers and items are loaded
    const isLoading = !layers || layers.length === 0 || layerItems?.length === 0;

    useEffect(() => {
        console.log('Storymap component mounts to DOM. Defining message handler...')

        const handleMessage = (event: MessageEvent) => {
            console.log('Storymap Received message:', event.data, 'by', window.origin, '. Received from:', event.origin);
    
            if (event.data.message === 'update') {
                const { params } = event.data;
        
                if (params) {
                    // Set orgId from the message, default to 9 if not provided
                    const orgId = params.organization_id || 9;
                    const locationId = params.location_id || null;
                    const boundingBox = params.area_view?.bounding_box || null;
                    const excludeIds = params.area_view?.exclude_ids || null;

                    // Refetch layers data as orgId changes
                    fetchLayersData(orgId, locationId, boundingBox, excludeIds);
                }
            }   
        };
    
        if (isIframe) {
            window.addEventListener("message", handleMessage);
            console.log('Message Event Listener Added by Dashboard!')
        } 
    
        return () => {
            if (isIframe) window.removeEventListener('message', handleMessage);
            console.log('Message Event Listener Removed by Dashboard!')
        };
    }, [isIframe]);

    useEffect(() => {
        console.log('Is Iframe:', isIframe, 'Parent:', window.parent, 'Current Window:', window);
    }, [isIframe]);

    return (
        <>
            {/* Show loading indicator if data is still loading */}
            {(isLoading || loading) && (
                <div className="loading-container-storymap">
                    <div className="loading-spinner-white"></div>
                </div>
            )}

            {/* Main content */}
            <div className="p-6 w-full bg-[#21506F] bg-opacity-70">
                {/* If layers and items are loaded, check for the active layer */}
                {!activeLayer ? (
                    <div className="mt-4 p-4 text-center text-white">
                        <p>No active layer selected.</p>
                    </div>
                ) : (
                    <>
                        {/* Item Cards */}
                        <div className="grid grid-cols-1 gap-4 mt-4">
                            {layerItems?.map((layerItem, index) => (
                                <StoryCard 
                                    key={index} 
                                    width="w-full" 
                                    layerItem={layerItem}
                                    isActive={activeCardId === layerItem.id}
                                    setActiveCardId={setActiveCardId}
                                />
                            ))}
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

export default Storymap;